import { useEffect, useState, useCallback } from 'react';
import { createAllowedDomain, updateAllowedDomain } from "../../../service/AdminService/adminDomainService";
import CustomModal from '../../../components/global/CustomModal/CustomModal';
import { showErrorMessage, showSuccessMessage } from '../../../components/shared/pagination/messages';
import Form from '../../../components/shared/new Form/Fields/Form';
import { BASE_FIELDS_DOMAIN, STATUS_FIELD_DOMAIN } from '../../../assets/constants/constants';

const DomainModal = ({
    isModalOpen,
    handleCloseModal,
    getDomains,
    setLoading,
    loading,
    selectedDomain
}) => {
    const isEditMode = !!selectedDomain?.id;
    const [formData, setFormData] = useState({ domain: "", isActive: "true" });
    const [errors, setErrors] = useState({});

    const fields = isEditMode ? [...BASE_FIELDS_DOMAIN, STATUS_FIELD_DOMAIN] : BASE_FIELDS_DOMAIN;

    useEffect(() => {
        if (isModalOpen) {
            setFormData({
                domain: selectedDomain?.domain || "",
                isActive: selectedDomain?.id ? String(selectedDomain.isActive) : "true",
            });
            setErrors({});
        }
    }, [isModalOpen, selectedDomain]);

    const handleChange = useCallback((name, value) => {
        setFormData((prev) => ({ ...prev, [name]: value }));
        
        if (errors[name]) {
            setErrors((prev) => {
                const { [name]: removed, ...rest } = prev;
                return rest;
            });
        }
    }, [errors]);

    const handleSubmit = async () => {
        if (!formData.domain) {
            setErrors({ domain: "Domain name is required!" });
            return;
        }

        try {
            setLoading(true);
            const isTrueSet = (formData.isActive === 'true' || formData.isActive === true);

            const payload = {
                domain: formData.domain,
                isActive: isTrueSet
            };

            let result;
            if (isEditMode) {
                result = await updateAllowedDomain(selectedDomain.id, payload);
            } else {
                result = await createAllowedDomain(payload.domain);
            }

            showSuccessMessage(result.message || "Success");
            if (getDomains) getDomains();
            handleCloseModal();
        } catch (error) {
            showErrorMessage(error?.message || "An error occurred");
        } finally {
            setLoading(false);
        }
    };

    return (
        <CustomModal
            title={isEditMode ? "Update Allowed Domain" : "Add New Allowed Domain"}
            visible={isModalOpen}
            onClose={handleCloseModal}
        >
            <Form
                fields={fields}
                formData={formData}
                onChange={handleChange}
                errors={errors}
                onSubmit={handleSubmit}
                onCancel={handleCloseModal}
                isSubmitting={loading}
                showClearButton={false}
                showCancelButton={true}
                sectionConfig={{ "Domain Details": { columns: 1 } }}
            />
        </CustomModal>
    );
};

export default DomainModal;